import { Grid } from '@mui/material';
import ProductionCardLoader from './ProductionCardLoader';

const StoreCardLoader = ({ className }: any) => {
  return (
    <>
      <div className={className ? className : `card-loader-sction`}>
        <Grid container rowGap={0} columnSpacing={2}>
          <Grid item lg={2.4} md={3} sm={4} xs={6}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={6}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={6}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={6}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={6}>
            <ProductionCardLoader />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default StoreCardLoader;
